import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import ReactDOM from 'react-dom';
import './index.css';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveBar } from '@nivo/bar'
import Holidays from './holidays.js';
import Travel from './travel.js';

var unselected = '#d9d8d4'
var selected = '#791da3'

class Bar extends React.Component {
  constructor(props) {
    super(props);
    this.data = [
      {
        "entity": "You",
        "travel": this.props.holidayCarbon,
        "holiday": this.props.travelCarbon
      },
      {
        "entity": "UK",
        "travel": 15,
        "holiday": 10
      }
    ]
    };

    render() {
      return (
        <div style={{height: 250}}>
                  <ResponsiveBar
                    data={[
                      {
                        "entity": "You",
                        "travel": this.props.travelCarbon,
                        "holiday": this.props.holidayCarbon
                      },
                      {
                        "entity": "UK",
                        "travel": 2500,
                        "holiday": 600
                      }
                    ]}
                    keys={[ 'travel', 'holiday' ]}
                    indexBy="entity"
                    margin={{ top: 50, right: 200, bottom: 50, left: 100 }}
                    padding={0.3}
                    layout="horizontal"
                    colors={{ scheme: 'set1' }}
                    defs={[
                        {
                            id: 'dots',
                            type: 'patternDots',
                            background: 'inherit',
                            color: '#38bcb2',
                            size: 4,
                            padding: 1,
                            stagger: true
                        },
                        {
                            id: 'lines',
                            type: 'patternLines',
                            background: 'inherit',
                            color: '#eed312',
                            rotation: -45,
                            lineWidth: 6,
                            spacing: 10
                        }
                    ]}
                    fill={[
                        {
                            match: {
                                id: 'fries'
                            },
                            id: 'dots'
                        },
                        {
                            match: {
                                id: 'sandwich'
                            },
                            id: 'lines'
                        }
                    ]}
                    borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 10,
                        tickRotation: 0,
                        legend: 'Carbon Foootprint',
                        legendPosition: 'middle',
                        legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendPosition: 'middle',
                        legendOffset: -40
                    }}
                    enableGridY={false}
                    enableLabel={false}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'right',
                            direction: 'column',
                            justify: false,
                            translateX: 115,
                            translateY: 0,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemsSpacing: 0,
                            symbolSize: 20,
                            itemDirection: 'left-to-right'
                        }
                    ]}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    markers={[
                      {
                        axis: 'x',
                        value: 540,
                        lineStyle: { stroke: 'rgba(0, 0, 0, .9)', strokeWidth: 4 },
                        legend: 'Paris Agreement',
                        legendOrientation: 'vertical',
                        legendOffset: 0
                      },
                    ]}
                />
                </div>

      )
    }

  }


class Site extends React.Component {
    constructor(props) {
        super(props);
        this.updateHoliday = this.updateHoliday.bind(this);
        this.updateTravel = this.updateTravel.bind(this);
        this.state = {
            carFill: unselected,
            holidayCarbon: 0.0,
            travelCarbon: 0.0,
            totalCarbon: 0.0
        };
    }


    updateHoliday(value) {
      var holiday = this.state.holidayCarbon + value;
      var total = this.state.totalCarbon + value;
      this.setState({holidayCarbon: holiday,
                      totalCarbon: total});
    }

    updateTravel(value) {
      var travel = this.state.travelCarbon + value;
      var total = this.state.totalCarbon + value;
      this.setState({travelCarbon: travel,
                      totalCarbon: total
                    });
    }

    render() {
        return (
            <div>
                <Tabs>
                  <TabList>
                    <Tab><b>Daily Travel</b></Tab>
                    <Tab><b>Holiday Travel</b></Tab>
                  </TabList>
                  <TabPanel>
                    <Travel update = {this.updateTravel}
                    carFill = {this.state.carFill}/>
                  </TabPanel>
                  <TabPanel>
                    <Holidays updateHoliday = {this.updateHoliday} />
                  </TabPanel>
                </Tabs>
                <Bar travelCarbon={this.state.travelCarbon} holidayCarbon={this.state.holidayCarbon} />
                
                
            </div>
        )
    }

}

class Pie extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        holidayCarbon: 0,
        TravelCarbon: 0
    };
    this.data = [
      {
        "id": "co2",
        "label": "co2",
        "value": 20,
        "color": "#ff2200"
      },
      {
        "id": "other",
        "label": "",
        "value": 80,
        "color": "#25d10a"
      }
    ];
  }
  render() {
    return (
        <div style={{height: 200}}>
            <ResponsivePie
                data={this.data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                startAngle={-134}
                endAngle={134}
                innerRadius={0.5}
                padAngle={0.7}
                cornerRadius={3}
                colors={{ scheme: 'category10' }}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
                enableRadialLabels={false}
                enableSlicesLabels={false}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={false}
            />
        </div>
    )
  }
}

 
  
  // ========================================
  
  ReactDOM.render(
    <div>
        <Site />
    </div>,
    document.getElementById('root')
  );
  
